<ng-container *ngIf="tableData">
    <div [ngClass]="{ 'card-panel': tableData.infoTableSectionTitle }">
        <div class="p-3" *ngIf="tableData.infoTableSectionTitle">
            <app-section-title
                [sectionTitleConfig]="tableData.infoTableSectionTitle"
            ></app-section-title>
        </div>
        <div
            *ngFor="let infoTableData of tableData.infoTableData"
            [ngClass]="{
                'pb-4 px-3 px-lg-5 ': tableData.infoTableSectionTitle
            }"
        >
            <h4 >{{ infoTableData.cardHeader }}</h4>
            <div
                class="card-panel"
                [ngStyle]="{
                    'background-color':
                        tableData.infoTableBackground.backgroundColor
                }"
            >
                <div class="card-body">
                    <div
                        class="table-responsive"
                        *ngFor="
                            let header of infoTableData.headers;
                            let i = index
                        "
                    >
                        <table class="table table-striped info-table">
                            <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        *ngFor="
                                            let headerKey of header
                                                | keyvalue: originalOrder
                                        "
                                    >
                                        {{ headerKey.value }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    [ngStyle]="{
                                        'background-color':
                                            tableData.infoTableBackground
                                                .rowColor
                                    }"
                                >
                                    <td
                                        *ngFor="
                                            let rowKey of infoTableData.data[i]
                                                | keyvalue: originalOrder
                                        "
                                    >
                                        {{ rowKey.value }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- <div class="card-panel">
    <div class="card-body">
        <div class="table-responsive">
            <table class="table table-striped info-table">
                <thead>
                    <tr>
                        <th scope="col" *ngFor="let header of objectKeys(tableData.headers[0])">
                            {{tableData.headers[0][header]}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngFor="let item of objectKeys(tableData.data[0])">{{tableData.data[0][item]}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="table-responsive">
            <table class="table table-striped info-table">
                <thead>
                    <tr>
                        <th scope="col">Α.Τ.ΑΚ.</th>
                        <th scope="col">Είδος Ακινήτου</th>
                        <th scope="col">ΑΦΜ Ιδιοκτήτη</th>
                        <th scope="col">Ονοματεπώνυμο/Επωνυμία</th>
                        <th scope="col">Όροφος,Εμβαδόν</th>
                        <th scope="col">Ενέργεια</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><span class="enarksi-table-text--italic">Α.Τ.ΑΚ.: </span>
                            <span class="font-weight-bold">123456789012131</span>
                            <br>
                        </td>
                        <td>Επαγγελματική Στέγη</td>
                        <td>222233366</td>
                        <td class="font-weight-bold">ΕΥΑΓΓΕΛΟΣ ΠΑΠΑΝΤΝΩΝΙΟΥ</td>
                        <td><span class="enarksi-table-text--italic">Όροφος:</span> Ισόγειο
                        </td>
                        <td>
                            <button class="btn btn-secondary">Επιλογή</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div> -->

<!-- <app-card-panel>
    <div class="table-responsive">
        <table class="table table-striped info-table">
            <thead>
                <tr>
                    <th scope="col">Α.Τ.ΑΚ.</th>
                    <th scope="col">Είδος Ακινήτου</th>
                    <th scope="col">ΑΦΜ Ιδιοκτήτη</th>
                    <th scope="col">Ονοματεπώνυμο/Επωνυμία</th>
                    <th scope="col">Όροφος,Εμβαδόν</th>
                    <th scope="col">Ενέργεια</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><span class="enarksi-table-text--italic">Α.Τ.ΑΚ.: </span>
                        <span class="font-weight-bold">123456789012131</span>
                        <br>
                    </td>
                    <td>Επαγγελματική Στέγη</td>
                    <td>222233366</td>
                    <td class="font-weight-bold">ΕΥΑΓΓΕΛΟΣ ΠΑΠΑΝΤΝΩΝΙΟΥ</td>
                    <td><span class="enarksi-table-text--italic">Όροφος:</span> Ισόγειο
                    </td>
                    <td>
                        <button class="btn btn-secondary">Επιλογή</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="table-responsive">
        <table class="table table-striped info-table">
            <thead>
                <tr>
                    <th scope="col">Α.Τ.ΑΚ.</th>
                    <th scope="col">Είδος Ακινήτου</th>
                    <th scope="col">ΑΦΜ Ιδιοκτήτη</th>
                    <th scope="col">Ονοματεπώνυμο/Επωνυμία</th>
                    <th scope="col">Όροφος,Εμβαδόν</th>
                    <th scope="col">Ενέργεια</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><span class="enarksi-table-text--italic">Α.Τ.ΑΚ.: </span>
                        <span class="font-weight-bold">123456789012131</span>
                        <br>
                    </td>
                    <td>Επαγγελματική Στέγη</td>
                    <td>222233366</td>
                    <td class="font-weight-bold">ΕΥΑΓΓΕΛΟΣ ΠΑΠΑΝΤΝΩΝΙΟΥ</td>
                    <td><span class="enarksi-table-text--italic">Όροφος:</span> Ισόγειο
                    </td>
                    <td>
                        <button class="btn btn-secondary">Επιλογή</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</app-card-panel>

<hr>

<app-card-panel>
    <div class="px-3">

        <app-section-title imgPath={{imgPath}} altText={{altText}} title={{sectionTitle}}></app-section-title>

        <h4 class="mt-3 font-italic">Στοιχεία πωλητή με ΑΦΜ : 12345678911</h4>

        <app-card-panel [incomingClasses]="'gray-background'">
            <div class="table-responsive">
                <table class="table table-striped info-table">
                    <thead>
                        <tr>
                            <th scope="col">Α.Τ.ΑΚ. και Αριθμός Παροχής</th>
                            <th scope="col">Είδος Ακινήτου</th>
                            <th scope="col">ΑΦΜ Ιδιοκτήτη</th>
                            <th scope="col">Ονοματεπώνυμο/Επωνυμία</th>
                            <th scope="col">Όροφος,Εμβαδόν</th>
                            <th scope="col">Ενέργεια</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span class="enarksi-table-text--italic">Α.Τ.ΑΚ.: </span>
                                <span class="font-weight-bold">123456789012131</span>
                                <br>
                            </td>
                            <td>Επαγγελματική Στέγη</td>
                            <td>222233366</td>
                            <td class="font-weight-bold">ΕΥΑΓΓΕΛΟΣ ΠΑΠΑΝΤΝΩΝΙΟΥ</td>
                            <td><span class="enarksi-table-text--italic">Όροφος:</span> Ισόγειο
                            </td>
                            <td>
                                <button class="btn btn-secondary">Επιλογή</button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="table table-striped info-table">
                    <thead>
                        <tr>
                            <th scope="col">Α.Τ.ΑΚ. και Αριθμός Παροχής</th>
                            <th scope="col">Είδος Ακινήτου</th>
                            <th scope="col">ΑΦΜ Ιδιοκτήτη</th>
                            <th scope="col">Ονοματεπώνυμο/Επωνυμία</th>
                            <th scope="col">Όροφος,Εμβαδόν</th>
                            <th scope="col">Ενέργεια</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span class="enarksi-table-text--italic">Α.Τ.ΑΚ.: </span>
                                <span class="font-weight-bold">123456789012131</span>
                                <br>
                            </td>
                            <td>Επαγγελματική Στέγη</td>
                            <td>222233366</td>
                            <td class="font-weight-bold">ΕΥΑΓΓΕΛΟΣ ΠΑΠΑΝΤΝΩΝΙΟΥ</td>
                            <td><span class="enarksi-table-text--italic">Όροφος:</span> Ισόγειο
                            </td>
                            <td>
                                <button class="btn btn-secondary">Επιλογή</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </app-card-panel>

        <h4 class="mt-5 font-italic">Στοιχεία πωλητή με ΑΦΜ : 12345678911</h4>

        <app-card-panel>
            <div class="table-responsive">
                <table class="table table-striped info-table">
                    <thead>
                        <tr>
                            <th scope="col">Α.Τ.ΑΚ. και Αριθμός Παροχής</th>
                            <th scope="col">Είδος Ακινήτου</th>
                            <th scope="col">ΑΦΜ Ιδιοκτήτη</th>
                            <th scope="col">Ονοματεπώνυμο/Επωνυμία</th>
                            <th scope="col">Όροφος,Εμβαδόν</th>
                            <th scope="col">Ενέργεια</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span class="enarksi-table-text--italic">Α.Τ.ΑΚ.: </span>
                                <span class="font-weight-bold">123456789012131</span>
                                <br>
                            </td>
                            <td>Επαγγελματική Στέγη</td>
                            <td>222233366</td>
                            <td class="font-weight-bold">ΕΥΑΓΓΕΛΟΣ ΠΑΠΑΝΤΝΩΝΙΟΥ</td>
                            <td><span class="enarksi-table-text--italic">Όροφος:</span> Ισόγειο
                            </td>
                            <td>
                                <button class="btn btn-secondary">Επιλογή</button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="table table-striped info-table">
                    <thead>
                        <tr>
                            <th scope="col">Α.Τ.ΑΚ. και Αριθμός Παροχής</th>
                            <th scope="col">Είδος Ακινήτου</th>
                            <th scope="col">ΑΦΜ Ιδιοκτήτη</th>
                            <th scope="col">Ονοματεπώνυμο/Επωνυμία</th>
                            <th scope="col">Όροφος,Εμβαδόν</th>
                            <th scope="col">Ενέργεια</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span class="enarksi-table-text--italic">Α.Τ.ΑΚ.: </span>
                                <span class="font-weight-bold">123456789012131</span>
                                <br>
                            </td>
                            <td>Επαγγελματική Στέγη</td>
                            <td>222233366</td>
                            <td class="font-weight-bold">ΕΥΑΓΓΕΛΟΣ ΠΑΠΑΝΤΝΩΝΙΟΥ</td>
                            <td><span class="enarksi-table-text--italic">Όροφος:</span> Ισόγειο
                            </td>
                            <td>
                                <button class="btn btn-secondary">Επιλογή</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </app-card-panel>
    </div>


</app-card-panel> -->
